import { Component, OnInit } from '@angular/core';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CsPopupService } from 'src/app/shared/components/cs-popup/cs-popup.service';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { WalletDialogType, WalletService } from '../wallet.service';
import { AppService } from './../../../app.service';

@Component({
  selector: 'saved-address',
  standalone: true,
  imports: [CSIconButtonComponent, CSButtonComponent, EmptyModule],
  templateUrl: './saved-address.component.html',
  styleUrl: './saved-address.component.scss',
})
export class SavedAddressComponent implements OnInit {
  constructor(
    public walletService: WalletService,
    private appService: AppService,
    private csPopupService: CsPopupService,
  ) {}
  /** 地址列表 */
  addressList: any = [];
  /** 是否正在加载地址列表 */
  addressLoading: boolean = false;

  ngOnInit(): void {
    this.getAddressList();
  }

  /** 獲取地址 */
  async getAddressList() {
    this.addressLoading = true;
    const params = {
      currency: '',
      isWhiteList: null,
      isUniversalAddress: null,
      address: '',
      isWithdraw: true,
      walletAddressType: '',
    };
    const data = await this.walletService.loadAddressList(params);
    this.addressList = data || [];
    this.addressLoading = false;
  }

  /** 返回上一頁 */
  goBack() {
    this.walletService.setWalletDialogType(WalletDialogType.DEPOSIT_WITHDRAW);
  }

  /** 去新增地址 */
  goAddEditAddress() {
    this.walletService.setWalletDialogType(WalletDialogType.ADD_EDIT_ADDRESS);
  }

  /**
   * 刪除地址
   *
   * @param id
   */
  deleteAddress(id: number) {
    this.walletService.otpType = 'DeleteTokenAddress';
    this.walletService.email = this.appService.userInfo$.getValue()?.email || '';
    this.walletService.addressId = id;
    this.walletService.setWalletDialogType(WalletDialogType.VERIFY_2FA);
  }

  /**
   * 打開刪除地址確認彈窗
   *
   * @param id 地址ID
   */
  onOpenCancel(id: number) {
    this.csPopupService.confirm({
      header: 'SAVED ADDRESS',
      title: 'Are you sure you want to delete this saved address?',
      message: 'You will no longer be able to use this saved address.',
      cancelText: 'Go back',
      confirmText: 'Delete',
      color: 'danger',
      confirmCallback: () => {
        this.deleteAddress(id);
      },
    });
  }
}
